<template>
    <div class="email-row" >
        <div class="customer-email-list">
            <div class="alert alert-success" role="alert" v-if="successMessage">
                {{ successMessage }}
            </div>
            <div class="alert alert-danger" role="alert" v-if="errorMessage">
                {{ errorMessage }}
            </div>

            <ul v-if="messages">
                <li class="list-row" :class="{ 'unread-mail': message && message.id == messageItem.id }" v-for="(messageItem, index) in messages">
                    <div class="mail-details-left">
                        <a href="javascript:void(0)" @click="openMessage(messageItem)">
                            <h3>{{messageItem.name}}</h3>
                            <div class="mail-subject">{{messageItem.quote_subject}}</div>
                            <p v-html="messageItem.message_body"></p>
                        </a>
                    </div>
                    <div class="mail-time-right">
                        <a v-if="messageItem.attachments && messageItem.attachments.length" href="#" class="attach-file"><i class="fa fa-paperclip" aria-hidden="true"></i></a>
                        <div class="time-dl">{{formatDate(messageItem.created_at)}}</div>
                    </div>
                </li>
                <!--<li class="list-row">
                    <div class="mail-details-left">
                        <a href="#">
                            <h3>Abraham Landau</h3>
                            <div class="mail-subject">Test</div>
                            <p>Lorem Ipsum is simply dummy text of the printing and typesetting industry.</p>
                        </a>
                    </div>
                    <div class="mail-time-right">
                        <a href="#" class="attach-file"><i class="fa fa-paperclip" aria-hidden="true"></i></a>
                        <div class="time-dl">4:40 PM</div>
                    </div>
                </li>
                <li class="list-row">
                    <div class="mail-details-left">
                        <a href="#">
                            <h3>Abraham Landau</h3>
                            <div class="mail-subject">Test</div>
                            <p>Lorem Ipsum is simply dummy text of the printing and typesetting industry.</p>
                        </a>
                    </div>
                    <div class="mail-time-right">
                        <a href="#" class="attach-file"><i class="fa fa-paperclip" aria-hidden="true"></i></a>
                        <div class="time-dl">4:40 PM</div>
                    </div>
                </li>-->
            </ul>
        </div>
        <div class="email-read-col" v-if="message">
            <div class="email-rfd-header" v-if="!isReply">
                <ul>
                    <li><a href="javascript:void(0)" @click="isReply=true"><span><i class="fa fa-reply" aria-hidden="true"></i></span> <span>Reply</span></a> </li>
                    <!--<li><a href="javascript:void(0)"><span><i class="fa fa-share" aria-hidden="true"></i></span> <span>Forward</span></a> </li>
                    <li><a href="javascript:void(0)"><span><i class="fa fa-trash" aria-hidden="true"></i></span> <span>Delete</span></a> </li>-->
                </ul>
            </div>
            <div class="mail-rfd-body" v-if="isReply">
                <label>Message Body : </label>

                <ckeditor v-model="form.message_body"
                          tag-name="textarea"
                          value=""
                          :config="editorConfigMin"></ckeditor>
                <br>
                <div class="row">
                    <div class="col-md-12">
                        <div class="add-attachment">
                            <div class="add-attchmnt">

                                <div class="form-group files vendor_mail_files color" >
                                    <vue-dropzone :options="dropzoneOptions"
                                                  :id="'item-dropzone-attach'"
                                                  v-on:vdropzone-sending="sendingEventQuoteAttachments"
                                                  v-on:vdropzone-success="(file, response) => afterUploadComplete(file, response)">
                                    </vue-dropzone>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div id="add_user_mail_attached">

                </div>
                <div id="add_user_mail">
                    <template v-for="(item, index) in form.files">
                        <div class="pdf-dwn-sec line-hgt">
                            <img v-if="item.image_type==1" :src="'/message_files/'+item.name" style="width:70px;height:70px" >{{item.name}}
                            <a class="fa fa-trash-alt fa-pull-right trash_btn" @click="deleteAttachFile(index)"></a>
                            <a :href="'/message_files/'+item.name" class="fa fa-download fa-pull-right" >download</a>
                        </div>
                    </template>
                </div>

                <div class="row">
                    <div class="col-sm-6 text-left">
                        <button type="button" @click="sendMail" class="btn btn-blue" id="reply_mail_btn">
                            <span class="send_text">Send&nbsp;</span>
                            <span v-if="loading" class="btn-icon-spinner">Sending&nbsp;<i class="fa fa-spinner btn-load-animate"></i></span>
                        </button>
                    </div>
                    <div class="col-sm-6 text-right">
                        <button type="button" class="btn btn-white" @click="isReply=false; resetReplyForm();">Close</button>
                    </div>
                </div>
            </div>
            <div class="mail-rfd-body">
                <div class="mailto-cl">
                    <div class="mail-avatar"></div>
                    <div class="send-details">
                        <div class="send-name">{{message.name}}</div>
                        <div class="send-date">{{formatDate(message.created_at)}}</div>
                    </div>
                </div>
                <div class="mail-subject"><h3>{{message.name}}</h3></div>
                <div class="mail-details-desp">
                    <p v-html="message.message_body"></p>
                </div>
                <!--<div class="mail-footer">
                    <p>Thanks</p>
                    <p>Mark</p>
                </div>-->
            </div>
        </div>
    </div>
</template>

<script>
import {mapState, mapActions, mapGetters} from 'vuex';
import axios from "axios";
import vue2Dropzone from 'vue2-dropzone'
import 'vue2-dropzone/dist/vue2Dropzone.min.css'

export default {
    name: "Inbox",
    props: ['quotation', 'messages', 'type', 'selected'],
    components: {
        vueDropzone: vue2Dropzone,
    },
    mounted() {
        if(this.selected)
            this.message = _.cloneDeep(this.selected);
    },
    data() {
        return {
            message: null,
            isReply: false,
            form: {
                message_body: "",
                attached_files: [],
                attachmentIds: [],
                files: []
            },
            editorConfigMin: {
                toolbar: [
                    [ 'Source', '-', 'Bold', 'Italic' ],
                    [ 'Styles', 'Format', 'Font', 'FontSize' ],
                ]
            },
            dropzoneOptions: {
                url: window.route('addMessageAttachment'),
                thumbnailWidth: 150,
                maxFilesize: 2048, //mb
                maxFiles: 10,
                addRemoveLinks: false,
                chunking: false,
                //chunkSize: 500, // bytes
                headers: {
                    "Authorization": 'Bearer ' + localStorage.getItem('token'),
                    "X-CSRF-TOKEN": document.head.querySelector("[name=csrf-token]").content
                }
            },
        }
    },
    methods: {
        ...mapActions([
            'setCommonErrors',
            'setErrorMessage',
            'setSuccessMessage',
            'setLoading',
        ]),
        openMessage(message) {
            this.message = _.cloneDeep(message);
        },
        resetReplyForm() {
            this.form = {
                message_body: "",
                attached_files: [],
                attachmentIds: [],
                files: []
            };
        },
        deleteVendorFile(index){
            // this.vendor_files.splice(id, 1);
            this.form.vendor_files.splice(index, 1);
        },
        deleteAttachFile(id, index){
            // this.vendor_files.splice(id, 1);
            this.form.files.splice(index, 1);
            this.form.attached_files.splice(index, 1);
            this.form.attachmentIds.splice(index, 1);
        },
        sendingEventQuoteAttachments(file, xhr, formData){
            // formData.append('quote_id', this.quotation.id);
        },
        afterUploadComplete(file, response) {
            if(response.success==true){
                //console.log(response)
                this.form.files.push(response);
                this.form.attached_files.push(response.name);
                this.form.attachmentIds.push(response.attachment_id);
            } else {
                this.setErrorMessage('File not uploaded successfully');
            }
        },
        sendMail() {
            let self = this;
            this.setLoading(true);
            this.setCommonErrors([]);
            this.setErrorMessage(null);

            let form = _.cloneDeep(self.form);

            let apiUrl = window.route('send_cus_mail');

            let payload = {
                customer_email: this.message ? this.message.customer_contact_email : null,
                customer_name: this.message ? this.message.contact_name : null,
                quote_num: this.quotation.quotation_number,
                quote_id: this.quotation.id,
                contact_id: this.message.contact_id,
                customer_id: this.message.customer_id,
                mail_id: this.message.mail_id,
                id: this.message.id,
                quote_subject: this.message.quote_subject,
                msgBody: form.message_body,
                attachments: form.attached_files,
                attachmentIds: form.attachmentIds
            };

            if (this.type == 'vendor') {
                apiUrl = window.route('send_ven_mail');

                payload = {
                    vendor_email: this.message ? this.message.ven_mail : null,
                    vendor_id: this.message.vendor_id,
                    contact_id: this.message.contact_id,
                    id: this.message.id,
                    mail_id: this.message.mail_id,
                    quote_subject: this.message.quote_subject,
                    quote_num: this.quotation.quotation_number,
                    quote_id: this.quotation.id,
                    msgBody: form.message_body,
                    attachments: form.attached_files,
                    attachmentIds: form.attachmentIds
                };
            } else {
                if (payload.customer_email == null || payload.customer_email == '') {
                    self.setErrorMessage("Customer email is not found! Please fix the customer data by editing customer info of the quote.");
                    this.setLoading(false);
                    return;
                }
            }


            return axios.post(apiUrl, payload, {
                validateStatus: function (status) {
                    return status < 500; // Resolve only if the status code is less than 500
                }
            })
                .then(({data}) => {
                    if (data.data) {
                        this.$emit('replyEmailSentEvent', data);
                        self.setSuccessMessage(data.message);
                        setTimeout(() => {
                            self.setSuccessMessage(null);
                        }, 5000);
                        this.isReply = false;
                        this.resetReplyForm();

                    } else {
                        self.setErrorMessage(data.errorMessage);
                        if (data.errors) {
                            self.setCommonErrors(data.errors);
                        }
                    }
                })
                .catch((error) => {
                    self.setErrorMessage(error.response && error.response.errorMessage ? error.response.errorMessage : error.message);

                })
                .finally(() => {
                    self.setLoading(false);

                });
        }
    },
    computed: {
        ...mapGetters([
            'errorMessage',
            'successMessage',
            'loading',
        ])
    }
}
</script>

<style scoped>

</style>
